import log from 'salvo-lite/log'
import Helpers from '../helpers/Helpers'
class Variants {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._variants = elem.querySelectorAll('[data-variant]')
        this._select = elem.querySelectorAll('select[name="id"]')
        this._options = elem.querySelectorAll('option')
        this._sku = document.querySelector('.product__sku')
        this._price = document.querySelector('.product__price')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        for (var i = 0; i < this._variants.length; i++) {
            let variant = this._variants[i]
            let variantID = variant.getAttribute('data-variant')
            let sku = variant.getAttribute('data-sku')
            let og = Helpers.formatMoney(variant.getAttribute('data-og-price'))
            let sale = Helpers.formatMoney(variant.getAttribute('data-sale-price'))
            variant.addEventListener('click', e => {
                this._updateSelect(variantID)
                this._updateSKU(sku)
                this._updatePrice(og, sale)
                if (window.location.pathname.includes('products')) {
                    this._updateURL(variantID)
                }
            })
        }
    }
    _updateSelect (variant) {
        const current = this._elem.querySelector('[selected]')
        current.removeAttribute('selected')
        for (var o = 0; o < this._options.length; o++) {
            let value = this._options[o].value
            if (value === variant) {
                this._options[o].setAttribute('selected', '')
            }
        }
    }
    _updatePrice (og, sale) {
        if (og !== '£0') {
            this._price.querySelector('.product-original-price').textContent = og
            this._price.querySelector('.money').textContent = sale
        } else {
            this._price.querySelector('.money').textContent = sale
        }
    }
    _updateSKU (sku) {
        if (this._sku) {
            this._sku.textContent = 'sku: ' + sku
        }
    }
    _updateURL (variant) {
        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant
        window.history.replaceState({ path: newurl }, '', newurl)
    }
}

export default Variants



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variants.js